
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recently-deceased",
      function () {
        return require("private-next-pages/recently-deceased.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recently-deceased"])
      });
    }
  